;
import {z} from "zod/v4";

export const JoyableColors = [
    "primary",
    "secondary",
    "tertiary",
    "success",
    "warning",
    "danger",
    "neutral",
] as const;
export const JoyableColor = z.enum(JoyableColors);
export type JoyableColor = z.infer<typeof JoyableColor>;


